import XLSX from 'xlsx';

export function create_workbook() {
  const wb = XLSX.utils.book_new();

  return wb;
}

export function create_worksheet(header, rows) {
  rows.unshift(header);
  const ws = XLSX.utils.aoa_to_sheet(rows);

  return ws;
}

export function add_worksheet(wb, ws, sheet_title) {
  XLSX.utils.book_append_sheet(wb, ws, sheet_title);
}

export function write_workbook(wb, file_name) {
  XLSX.writeFile(wb, file_name);
}

export function downloadXLSXFile(file_name, rows) {
  const wb = create_workbook();
  const header = rows.shift();
  const ws = create_worksheet(header, rows);
  add_worksheet(wb, ws, 'Reference');
  write_workbook(wb, file_name);
}


export async function loadWorkbook(file) {
  const reader = new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
  const data = await reader;
  const workbook = XLSX.read(data, {type: 'array'});
  return workbook;

  // const reference = workbook.Sheets['Reference'];
}

export function readSheet(wb, sheet_name) {
  const sheet = wb.Sheets[sheet_name];
  return XLSX.utils.sheet_to_json(sheet);
}



// WEBPACK FOOTER //
// ./src/components/workbook/index.js